import { DisclosureBaseFeature } from './disclosure-base.feature';

//used to access disclosures from data request
export const DisclosureFeature = () => {
    return <DisclosureBaseFeature withVivliId={false} />;
};
